import { jsx as _jsx } from "react/jsx-runtime";
import { isPresent } from "sprout-lib";
import { useMemo } from "react";
import { MoveItemsDialogProvider } from "./MoveItemsDialogContext";
import MoveItemsDialogInner from "./MoveItemsDialog_Inner";
const MoveItemsDialog = (props)=>{
    const { open , onRequestClose , onSuccess , selectedItems  } = props;
    const initialState = useMemo(()=>{
        const parentTopicIds = [
            ...new Set(selectedItems.map((item)=>{
                var ref;
                return (ref = item.parentTopic) === null || ref === void 0 ? void 0 : ref.id;
            })), 
        ].filter(isPresent);
        const differentParents = parentTopicIds.length > 1;
        let initialCurrentTopicId;
        if (!differentParents) {
            var ref1;
            const [selectedItem] = selectedItems;
            initialCurrentTopicId = (selectedItem === null || selectedItem === void 0 ? void 0 : (ref1 = selectedItem.parentTopic) === null || ref1 === void 0 ? void 0 : ref1.id) || undefined;
        }
        return {
            initialCurrentTopicId,
            itemIds: selectedItems.map((item)=>item.id),
            itemNodeIds: selectedItems.map((item)=>item.nodeId),
            onSuccess,
            onRequestClose
        };
    }, [
        onRequestClose,
        onSuccess,
        selectedItems
    ]);
    return /*#__PURE__*/ _jsx(MoveItemsDialogProvider, {
        initialState: initialState,
        children: /*#__PURE__*/ _jsx(MoveItemsDialogInner, {
            open: open,
            onRequestClose: onRequestClose,
            onSuccess: onSuccess
        })
    });
};
export default MoveItemsDialog;
